// Estado compartilhado do aviso de perda de bônus ao sacar Saldo Real —
// lido por components/base/modal/Global.vue (decide se renderiza
// WithdrawBonusLossAlert em vez do <BaseModal>+<Withdraw>) e por
// components/withdraw/BonusLossAlert.vue (decide se o próprio componente se
// mostra). Extraído pra um só lugar pra não deixar as duas condições
// divergirem. Quem chama resetForNewWithdraw a cada abertura nova é
// usePayments.openWithdrawModal (useState sobrevive ao fechar/reabrir).
export const useWithdrawBonusLossAlert = () => {
  const { modalType } = storeToRefs(useLayoutStore());
  const { bonusWallet, hasLoadedWallet } = storeToRefs(useWalletStore());

  const isBonusLossConfirmed = useState(
    'withdraw-bonus-loss-confirmed',
    () => false,
  );

  // Foto do saldo bônus tirada NA ABERTURA (ver resetForNewWithdraw), não
  // reativa ao vivo a bonusWallet.credit — se o saldo chegasse DEPOIS do
  // <Withdraw> já montado (fetch mais lento que o normal), o v-else-if em
  // Global.vue desmontaria o formulário na hora pra empurrar este aviso por
  // cima, perdendo o que o usuário já tinha digitado.
  const hadBonusAtOpen = useState('withdraw-had-bonus-at-open', () => false);

  // A foto só é confiável se hasLoadedWallet já era true NO MOMENTO da
  // abertura (getWallet já resolveu ao menos uma vez — sucesso ou erro, ver
  // stores/wallet.ts) — sem isso credit pode estar zerado só porque o fetch
  // ainda não voltou, não porque o usuário não tem bônus. Nesse caso volta a
  // seguir bonusWallet.value.credit ao vivo (aceitando o custo do remonte
  // acima) em vez de congelar um falso "sem bônus".
  const snapshotTaken = useState('withdraw-bonus-snapshot-taken', () => false);

  const shouldShowBonusLossAlert = computed<boolean>(
    () =>
      modalType.value === 'withdraw' &&
      (snapshotTaken.value
        ? hadBonusAtOpen.value
        : bonusWallet.value.credit > 0) &&
      !isBonusLossConfirmed.value,
  );

  function resetForNewWithdraw() {
    isBonusLossConfirmed.value = false;
    snapshotTaken.value = hasLoadedWallet.value;
    hadBonusAtOpen.value = bonusWallet.value.credit > 0;
  }

  return {
    isBonusLossConfirmed,
    shouldShowBonusLossAlert,
    resetForNewWithdraw,
  };
};
